"use client";

import React, { forwardRef } from "react";
import styled from "styled-components";
import { backgroundColorLevelCurrent, borderColorTertiary, boxShadowRaised, boxShadowDetached, boxShadowOverlaid, boxShadowPoppedOut, borderRadius, backgroundColorLevel2, backgroundColorLevel3, backgroundColorLevel4, backgroundColorLevel5 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const boxShadowsByDepth = {
  raised: boxShadowRaised,
  detached: boxShadowDetached,
  overlaid: boxShadowOverlaid,
  poppedOut: boxShadowPoppedOut
};
const ActualCard = styled.div.withConfig({
  componentId: "sc-14wiswp-0"
})(["background-color:", ";border:1px solid ", ";border-radius:", ";box-shadow:", ";&{--background-color-level-current:", ";background:", ";}& &{--background-color-level-current:", ";}& & &{--background-color-level-current:", ";}& & & &{--background-color-level-current:", ";}"], backgroundColorLevelCurrent, borderColorTertiary, borderRadius, ({
  $depth
}) => boxShadowsByDepth[$depth], backgroundColorLevel2, backgroundColorLevelCurrent, backgroundColorLevel3, backgroundColorLevel4, backgroundColorLevel5);

/**
 * A `Card` is a container that adds visual weight to content and implies interactivity. A `Card` with content creates a tile.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Content to render inside the Card
 * @param {"raised" | "detached" | "overlaid" | "poppedOut"} [props.depth] - How the card should be rendered relative to surrounding layers
 * @param {React.ElementType} [props.renderAs] - The HTML tag string (e.g., "div") or React component to render as.
 * @param {React.Ref} ref - Ref forwarded to the underlying button element.
 * @returns {React.ReactNode} The Card element
 */
const CardComponent = ({
  renderAs = "div",
  depth = "raised",
  ...props
}, ref) => /*#__PURE__*/_jsx(ActualCard, {
  $depth: depth,
  ...props,
  as: renderAs,
  ref: ref
});
const Card = /*#__PURE__*/forwardRef(CardComponent);
Card.displayName = "Card";
export default Card;